module.exports = __webpack_public_path__ + "img/logo.c5e56307.png";